import * as React from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useState } from 'react';
function PaymentDetails({ registrationFees }) {
    const [amount, setAmount] = useState(registrationFees || 0);  // State for the amount input

    const handleAmountChange = (e) => {
        const value = e.target.value;
        // Ensure the input is numeric or empty
        if (/^\d*$/.test(value)) {
            setAmount(value);
        }
    };
    return (
        <>
            <Container fluid>
                <Row className='mt-4'>
                    <Col>
                        <Card>
                            <div style={{ textAlign: "center" }}>
                                <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                    className='mb-3  mt-2'>Payment</Form.Label>
                            </div>
                            <Card.Body>
                                <Form className='text_c'>
                                    <Row>
                                        <Col xl={12} lg={12} md={12} xs={12} s={12}>

                                            <div>
                                                <Container>
                                                    <Form.Label style={{ fontSize: "18px", fontWeight: "600" }}
                                                        className='mb-3  mt-2'>Registration / Application Fees To Pay</Form.Label>

                                                    <hr style={{ margin: "1rem 8rem", color: "#8697c4" }}></hr>
                                                    <div style={{ display: " inline-flex", alignItems: "center" }}>
                                                        <CurrencyRupeeIcon style={{ fontSize: "30px", color: "#6e48aa" }} />
                                                        <Form.Control
                                                            type="text"
                                                            value={amount}
                                                            onChange={handleAmountChange}
                                                            style={{
                                                                width: '100px', textAlign: 'start', border: "none", fontSize: "20px",
                                                                fontWeight: "600"
                                                            }}
                                                        />
                                                    </div>
                                                    <hr style={{ margin: "1rem 8rem", color: "#8697c4" }}></hr>

                                                    <Row>
                                                        <Col> 
                                                            <Button variant="primary" type="button" className='button mt-2'
                                                            style={{    display: "inline",
                                                                width: "50%"}}
                                                            >Pay Now
                                                            </Button>


                                                            <p style={{marginTop: "15px",color: "#000", fontweight: "700", texttransform: "capitalize"}}>
                                                                Note : wait for 24 hours in case of payment deducted and not reflected on registration portal.
                                                            </p>

                                                        </Col>

                                                    </Row>

                                                    
                                                </Container>

                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default PaymentDetails;